import { notifListActions } from './NotificationsActions';


const initState = {
    showSpinner: true,
    notifList: [],
    error: null,
    currentPage: 1,
    totalPages: 1,
    notifsCount: 0
}


export default function NotificationsPageReducer(state = initState, action) {
    switch (action.type) {
        case notifListActions.toggleSpinner:
            return toggleSpinner(state, action);
        case notifListActions.showSearchSpinner:
            return showSearchSpinner(state, action)
        case notifListActions.hideSearchSpinner:
            return hideSearchSpinner(state, action)
        case notifListActions.setError:
            return setError(state, action);
        case notifListActions.setNotifList:
            return setNotifList(state, action);
        case notifListActions.setCurrentPage:
            return setCurrentPage(state, action);
        case notifListActions.setTotalPages:
            return setTotalPages(state, action);
        case notifListActions.setNotifsCount:
            return setNotifsCount(state, action);
        default:
            return state;
    }
}


function setNotifList(state, { payload }) {
    return {
        ...state,
        notifList: payload
    }
}

function setError(state, { payload }) {
    return {
        ...state,
        error: payload,
    }
}

function toggleSpinner(state, { payload }) {
    return {
        ...state,
        showSpinner: payload
    }
}

function hideSearchSpinner(state) {
    return {
        ...state,
        searchSpinner: false
    }
}

function showSearchSpinner(state) {
    return {
        ...state,
        searchSpinner: true,
    }
}

function setCurrentPage(state, { payload }) {
    return {
        ...state,
        currentPage: payload
    }
}

function setTotalPages(state, { payload }) {
    return {
        ...state,
        totalPages: payload
    }
}

function setNotifsCount(state, { payload }) {
    return {
        ...state,
        notifsCount: payload
    }
}
